const projectEnvVariables = {
  VITE_REACT_APP_CLIENT_ID: "${VITE_REACT_APP_CLIENT_ID}",
  VITE_REACT_APP_HOMEPAGE: "${VITE_REACT_APP_HOMEPAGE}",
  VITE_REACT_APP_API_PATH: "${VITE_REACT_APP_API_PATH}",
  VITE_REACT_APP_ENV: "${VITE_REACT_APP_ENV}",
  VITE_REACT_APP_METRICS_APP_ID: "${VITE_REACT_APP_METRICS_APP_ID}",
  VITE_REACT_APP_METRICS_CLIENT_TOKEN: "${VITE_REACT_APP_METRICS_CLIENT_TOKEN}",
  VITE_REACT_APP_METRICS_SITE: "${VITE_REACT_APP_METRICS_SITE}",
  VITE_REACT_APP_METRICS_SERVICE: "${VITE_REACT_APP_METRICS_SERVICE}",
  VITE_REACT_APP_PRIVACY_POLICY_URL: "${VITE_REACT_APP_PRIVACY_POLICY_URL}",
  VITE_REACT_APP_NEED_HELP_EMAIL: "${VITE_REACT_APP_NEED_HELP_EMAIL}",
  VITE_REACT_APP_NEED_TEAM_EMAIL: "${VITE_REACT_APP_NEED_TEAM_EMAIL}",
  VITE_REACT_APP_TEAM_CONTACT_MAIL: "${VITE_REACT_APP_TEAM_CONTACT_MAIL}",
  VITE_REACT_APP_TERM_OF_USE_URL: "${VITE_REACT_APP_TERM_OF_USE_URL}",
  VITE_REACT_APP_AUTH0_DOMAIN: "${VITE_REACT_APP_AUTH0_DOMAIN}",
  VITE_REACT_APP_AUTH0_CLIENT_ID: "${VITE_REACT_APP_AUTH0_CLIENT_ID}",
  VITE_REACT_APP_ACCIDENT_BENCHMARKS_URL:
    "${VITE_REACT_APP_ACCIDENT_BENCHMARKS_URL}",
  VITE_REACT_APP_BASIC_LIFE_BENCHMARKS_URL:
    "${VITE_REACT_APP_BASIC_LIFE_BENCHMARKS_URL}",
  VITE_REACT_APP_CANCER_BENCHMARKS_URL:
    "${VITE_REACT_APP_CANCER_BENCHMARKS_URL}",
  VITE_REACT_APP_CRITICAL_ILLNESS_BENCHMARKS_URL:
    "${VITE_REACT_APP_CRITICAL_ILLNESS_BENCHMARKS_URL}",
  VITE_REACT_APP_DENTAL_BENCHMARKS_URL:
    "${VITE_REACT_APP_DENTAL_BENCHMARKS_URL}",
  VITE_REACT_APP_DENTAL_DUAL_BENCHMARKS_URL:
    "${VITE_REACT_APP_DENTAL_DUAL_BENCHMARKS_URL}",
  VITE_REACT_APP_EAP_BENCHMARKS_URL: "${VITE_REACT_APP_EAP_BENCHMARKS_URL}",
  VITE_REACT_APP_HOSPITAL_BENCHMARKS_URL:
    "${VITE_REACT_APP_HOSPITAL_BENCHMARKS_URL}",
  VITE_REACT_APP_LTD_BENCHMARKS_URL: "${VITE_REACT_APP_LTD_BENCHMARKS_URL}",
  VITE_REACT_APP_STD_BENCHMARKS_URL: "${VITE_REACT_APP_STD_BENCHMARKS_URL}",
  VITE_REACT_APP_VISION_BENCHMARKS_URL:
    "${VITE_REACT_APP_VISION_BENCHMARKS_URL}",
  VITE_REACT_APP_VOLUNTARY_LIFE_BENCHMARKS_URL:
    "${VITE_REACT_APP_VOLUNTARY_LIFE_BENCHMARKS_URL}",
  VITE_REACT_APP_PORTAL_API_URL: "${VITE_REACT_APP_PORTAL_API_URL}",
  VITE_ENABLE_API_MOCKING: "${VITE_ENABLE_API_MOCKING}",
  VITE_TIME_TRACKING_ENABLED: "${VITE_TIME_TRACKING_ENABLED}",
  VITE_REACT_APP_GROWTHBOOK_API_HOST: "${VITE_REACT_APP_GROWTHBOOK_API_HOST}",
  VITE_REACT_APP_GROWTHBOOK_CLIENT_KEY:
    "${VITE_REACT_APP_GROWTHBOOK_CLIENT_KEY}",
  VITE_REACT_APP_WALK_ME_SRC: "${VITE_REACT_APP_WALK_ME_SRC}",
  VITE_REACT_APP_PENDO_API_KEY: "${VITE_REACT_APP_PENDO_API_KEY}",
  VITE_REACT_APP_VERSION: "${VITE_REACT_APP_VERSION}",
  VITE_REACT_APP_AG_GRID_LICENSE_KEY: "${VITE_REACT_APP_AG_GRID_LICENSE_KEY}",
  VITE_REACT_APP_JSD_WIDGET_KEY: "${VITE_REACT_APP_JSD_WIDGET_KEY}",
};

export const getProjectEnvVariables = () => {
  const envVariables = {};

  Object.keys(projectEnvVariables).forEach((key) => {
    envVariables[key] = !projectEnvVariables[key].includes("VITE_")
      ? projectEnvVariables[key]
      : import.meta.env[key];
  });

  return { envVariables };
};

const { envVariables } = getProjectEnvVariables();
export default envVariables;
